import { useState, useEffect, useRef } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import Header from '../../components/Header';
import ResponsiveTableRegion from '../../components/ResponsiveTableRegion';
import OrganizationFilter from '../../components/OrganizationFilter';
import OrganizationHierarchyView from '../../components/OrganizationHierarchyView';
import OrganizationPicker from '../../components/OrganizationPicker';
import { ventrisConfig } from '../../ventris.config';
import { focusFirstInvalidField } from '../../accessibility/focus';
import AsyncStatus from '../../components/AsyncStatus';

import GroupPageIcon from '../../icons/GroupPageIcon';
import FilterIcon from '../../icons/FilterIcon';
import ArchiveIcon from '../../icons/ArchiveIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import GroupIcon from '../../icons/GroupIcon';
import { getUseCaseTerminology } from '../../useCase';
import { ASSESSMENT_OPTIONS, AssessmentName } from '../../assessmentAccess';

type AdminOrganizationsProps = {
};

function AdminOrganizations({}: AdminOrganizationsProps) {
  const terms = getUseCaseTerminology();
  const [user, setUser] = useState([] as any);
  const [organizations, setOrganizations] = useState([] as any);
  const [organizationResults, setOrganizationResults] = useState([] as any);
  const [selectedOrganization, setSelectedOrganization] = useState({} as any);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState("" as any);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [validatedEdit, setValidatedEdit] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [showEditStudentModal, setShowEditStudentModal] = useState(false);
  const [errorCreate, setErrorCreate] = useState("");
  const [validatedCreate, setValidatedCreate] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusVariant, setStatusVariant] = useState("success");
  const [syncingOrganizationId, setSyncingOrganizationId] = useState("" as any);
  const [syncingSubscriptions, setSyncingSubscriptions] = useState(false);
  const [organizationsLoaded, setOrganizationsLoaded] = useState(false);
  const [loadingOrganizationResults, setLoadingOrganizationResults] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [savingOrganization, setSavingOrganization] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(20);
  const [totalSize, setTotalSize] = useState(0);
  const [sortFieldName, setSortFieldName] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [viewMode, setViewMode] = useState<"list" | "hierarchy">("hierarchy");
  const [hierarchyVersion, setHierarchyVersion] = useState(0);
  const [subscriptionPoolsEnabled, setSubscriptionPoolsEnabled] = useState(false);
  const [subscriptionPoolsEnabledForOrganization, setSubscriptionPoolsEnabledForOrganization] = useState(false);
  const [subscriptionPools, setSubscriptionPools] = useState([] as any[]);
  const [subscriptionPoolsLoading, setSubscriptionPoolsLoading] = useState(false);
  const [subscriptionPoolError, setSubscriptionPoolError] = useState("");
  const [subscriptionPoolBusy, setSubscriptionPoolBusy] = useState(false);
  const [newSubscriptionKey, setNewSubscriptionKey] = useState("");
  const [newSubscriptionPurchaserId, setNewSubscriptionPurchaserId] = useState("");
  const [poolMoveOrganizationId, setPoolMoveOrganizationId] = useState("");

  const [name, setName] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  const [subscriptionKey, setSubscriptionKey] = useState("");
  const [subscriptionStartDate, setSubscriptionStartDate] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [totalSeats, setTotalSeats] = useState("");
  const [organizationType, setOrganizationType] = useState("");
  const [useCase, setUseCase] = useState("School");
  const [assessmentAccess, setAssessmentAccess] = useState<AssessmentName[]>(["WRA"]);
  const [ssoShortCode, setSsoShortCode] = useState("");
  const [cognitoDomain, setCognitoDomain] = useState("");
  const [cognitoClientId, setCognitoClientId] = useState("");
  const [cognitoClientSecret, setCognitoClientSecret] = useState("");
  const [cognitoRedirectUri, setCognitoRedirectUri] = useState("");
  const [clearCognitoClientSecret, setClearCognitoClientSecret] = useState(false);
  const [useSchoolDayForRostering, setUseSchoolDayForRostering] = useState(false);
  const [schoolDayClientId, setSchoolDayClientId] = useState("");
  const [schoolDayClientSecret, setSchoolDayClientSecret] = useState("");
  const [clearSchoolDayClientSecret, setClearSchoolDayClientSecret] = useState(false);
  const [selectedUser, setSelectedUser] = useState({} as any);
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userRole, setUserRole] = useState("Clinician");
  const [userOrganizationId, setUserOrganizationId] = useState("");
  const [savingUser, setSavingUser] = useState(false);
  const [userEditError, setUserEditError] = useState("");
  const [selectedStudent, setSelectedStudent] = useState({} as any);
  const [studentFirstName, setStudentFirstName] = useState("");
  const [studentLastName, setStudentLastName] = useState("");
  const [studentGrade, setStudentGrade] = useState("");
  const [studentBirthdate, setStudentBirthdate] = useState("");
  const [studentCode, setStudentCode] = useState("");
  const [studentOrganizationId, setStudentOrganizationId] = useState("");
  const [savingStudent, setSavingStudent] = useState(false);
  const [studentEditError, setStudentEditError] = useState("");

  const editFormRef = useRef(null as any);
  const createFormRef = useRef(null as any);

  useEffect(() => {
    let currentUser = sessionStorage.getItem("current_user");
    setUser(JSON.parse(currentUser!));
    refreshCurrentUser();
    loadOrganizations();
  }, []);

  useEffect(() => {
    if (!user?.can_manage_assessment_access) {
      setSubscriptionPoolsEnabled(false);
      setSubscriptionPoolsEnabledForOrganization(false);
      return;
    }

    fetch(ventrisConfig.url + '/api/subscription-pools/capabilities', {
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    }).then((response) => response.ok ? response.json() : null)
      .then((data) => setSubscriptionPoolsEnabled(data?.supported === true && data?.enabled === true))
      .catch(() => setSubscriptionPoolsEnabled(false));
  }, [user?.can_manage_assessment_access]);

  const refreshCurrentUser = () => {
    const token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/account', {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then((response) => response.json()).then((account) => {
      sessionStorage.setItem("current_user", JSON.stringify(account));
      setUser(account);
    });
  };

  useEffect(() => {
    if (viewMode === "list") {
      loadOrganizationResults(page);
    }
  }, [page, sizePerPage, sortFieldName, sortDirection, organizationFilter, debouncedSearch, viewMode]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search);
      if (page !== 1) {
        setPage(1);
      }
    }, 400);

    return () => clearTimeout(timeoutId);
  }, [search]);

  const loadOrganizations = () => {
    let token = sessionStorage.getItem("token");
    setOrganizationsLoaded(false);
    fetch(ventrisConfig.url + '/api/organizations?compact=true', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setOrganizations(data);
      setOrganizationsLoaded(true);
    });
  }

  const loadOrganizationResults = (pageNumber: number) => {
    let token = sessionStorage.getItem("token");
    setLoadingOrganizationResults(true);
    fetch(ventrisConfig.url + '/api/organizations?page=' + pageNumber + '&sizePerPage=' + sizePerPage + '&sortField=' + sortFieldName + '&sortDirection=' + sortDirection + '&organization=' + organizationFilter + '&search=' + encodeURIComponent(debouncedSearch), {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setOrganizationResults(data.organizations);
      setTotalSize(data.total_records);
    }).finally(() => setLoadingOrganizationResults(false));
  }

  const updateCurrentUserUseCase = (organizationId: any, nextUseCase: string) => {
    if (String(user.organization_id) !== String(organizationId)) {
      return;
    }

    const currentUser = {
      ...user,
      organization_use_case: nextUseCase
    };
    sessionStorage.setItem("current_user", JSON.stringify(currentUser));
    setUser(currentUser);
  };

  const associatedOrganizationIds = () => {
    const ids = [
      user.organization_id,
      ...(user.assigned_organization_ids || []),
      ...(user.organization_ids || []),
    ];

    return ids.filter((id: any) => id !== null && id !== undefined && id !== "").map((id: any) => String(id));
  };

  const isAssociatedOrganization = (organizationId: any) => {
    return associatedOrganizationIds().includes(String(organizationId));
  };

  const normalizeSubscriptionKey = (value: any) => String(value || "").trim().toLowerCase();

  const hasSubscriptionKey = (value: any) => {
    const normalized = normalizeSubscriptionKey(value).replace(/-/g, "");
    return normalized !== "" && !/^0+$/.test(normalized);
  };

  const organizationById = (organizationId: any) => {
    return organizations.find((organization: any) => String(organization.id) === String(organizationId));
  };

  const organizationOrAncestorHasSubscriptionKey = (organizationId: any) => {
    let organization = organizationById(organizationId);
    const visited = new Set<string>();

    while (organization && !visited.has(String(organization.id))) {
      visited.add(String(organization.id));
      if (organization.subscription_managed === true || organization.subscription_managed_by_ancestor === true) {
        return true;
      }
      const subscriptionKey = organization.subscription_key
        || (String(user?.organization_id) === String(organization.id) ? user?.subscription_key : null);
      if (hasSubscriptionKey(subscriptionKey)) {
        return true;
      }
      organization = organizationById(organization.parent_organization_id);
    }

    return false;
  };

  const canEditIntegrationSettingsForOrganization = (organization: any) => {
    if (organization?.can_edit_integration_settings === true) {
      return true;
    }

    const fullOrganization = organizationById(organization?.id);
    if (fullOrganization?.can_edit_integration_settings === true) {
      return true;
    }

    const subscriptionKey = organization?.subscription_key
      || fullOrganization?.subscription_key
      || (String(user?.organization_id) === String(organization?.id) ? user?.subscription_key : null);

    return user?.role === "Admin"
      && String(user.organization_id) === String(organization?.id)
      && hasSubscriptionKey(subscriptionKey);
  };

  const canEditOrganization = (organization: any) => {
    if (canEditIntegrationSettingsForOrganization(organization)) {
      return true;
    }

    return !organization.schoolday_managed && !organization.schoolday_managed_by_ancestor && !isAssociatedOrganization(organization.id);
  };

  const editOrganization = (organization: any) => {
    if (isAssociatedOrganization(organization.id) && !canEditIntegrationSettingsForOrganization(organization)) {
      setStatusVariant("danger");
      setStatusMessage("Admins cannot edit organizations they are associated with.");
      return;
    }

    setSelectedOrganization(organization);
    setSelectedOrganizationId(organization.id);
    setName(organization.name);
    setOrganizationId(organization.parent_organization_id);
    setSubscriptionKey(organization.subscription_key || "");
    setSubscriptionStartDate((organization.starts_at || "").split("T")[0]);
    setExpirationDate((organization.expiration_date || "").split("T")[0]);
    setTotalSeats(organization.total_seats == null ? "" : String(organization.total_seats));
    setOrganizationType(organization.schoolday_type || "");
    setUseCase(organization.use_case || "School");
    setAssessmentAccess(
      (organization.effective_assessment_access || organization.assessment_access || ["WRA"])
        .filter((assessment: string) => ASSESSMENT_OPTIONS.includes(assessment as AssessmentName))
    );
    setSsoShortCode(organization.sso_short_code || "");
    setCognitoDomain(organization.cognito_domain || "");
    setCognitoClientId(organization.cognito_client_id || "");
    setCognitoClientSecret("");
    setCognitoRedirectUri(organization.cognito_redirect_uri || "");
    setClearCognitoClientSecret(false);
    setUseSchoolDayForRostering(!!organization.use_schoolday_for_rostering);
    setSchoolDayClientId(organization.schoolday_client_id || "");
    setSchoolDayClientSecret("");
    setClearSchoolDayClientSecret(false);
    setSubscriptionPools([]);
    setSubscriptionPoolsEnabledForOrganization(false);
    setSubscriptionPoolError("");
    setNewSubscriptionKey("");
    setNewSubscriptionPurchaserId(String(organization.id));
    setPoolMoveOrganizationId(String(organization.id));
    setShowEditModal(true);
    if (subscriptionPoolsEnabled) {
      loadSubscriptionPools(organization.id);
    }
  }

  const poolRequest = (path: string, method = "get", body?: any) => fetch(ventrisConfig.url + path, {
    method,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem("token")
    },
    body: body === undefined ? undefined : JSON.stringify(body)
  }).then(async (response) => {
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.success === false) {
      throw new Error(data.message || "The subscription order request failed.");
    }
    return data;
  });

  const loadSubscriptionPools = (organizationId: any) => {
    setSubscriptionPoolsLoading(true);
    setSubscriptionPoolError("");
    poolRequest('/api/organizations/' + organizationId + '/subscription-pools')
      .then((data) => {
        setSubscriptionPoolsEnabledForOrganization(data.enabled !== false);
        setSubscriptionPools(data.pools || []);
      })
      .catch((error) => setSubscriptionPoolError(error.message))
      .finally(() => setSubscriptionPoolsLoading(false));
  };

  const updatePoolFromResponse = (pool: any) => {
    setSubscriptionPools((current) => current.some((item) => item.id === pool.id)
      ? current.map((item) => item.id === pool.id ? pool : item)
      : [...current, pool]);
    setSubscriptionKey(pool.members?.find((member: any) => member.is_primary)?.subscription_key || "");
    setSubscriptionStartDate(pool.starts_at || "");
    setExpirationDate(pool.expiration_date || "");
    setTotalSeats(pool.total_seats == null ? "" : String(pool.total_seats));
  };

  const runPoolMutation = (path: string, method: string, body?: any) => {
    setSubscriptionPoolBusy(true);
    setSubscriptionPoolError("");
    return poolRequest(path, method, body)
      .then((data) => {
        if (data.pool) updatePoolFromResponse(data.pool);
        return data;
      })
      .catch((error) => {
        setSubscriptionPoolError(error.message);
        throw error;
      })
      .finally(() => setSubscriptionPoolBusy(false));
  };

  const addSubscriptionOrder = () => {
    if (!newSubscriptionKey.trim()) return;
    runPoolMutation('/api/organizations/' + selectedOrganization.id + '/subscription-orders', 'post', {
      subscription_key: newSubscriptionKey.trim(),
      purchasing_organization_id: newSubscriptionPurchaserId || selectedOrganization.id
    }).then((data) => {
      setNewSubscriptionKey("");
      if (data.sync?.status && data.sync.status !== 'synced') {
        setSubscriptionPoolError(data.sync.message || 'The order was linked but could not be synchronized.');
      }
    }).catch(() => undefined);
  };

  const setPrimarySubscription = (pool: any, subscriptionId: any) => {
    runPoolMutation('/api/subscription-pools/' + pool.id + '/primary', 'put', { subscription_id: subscriptionId }).catch(() => undefined);
  };

  const syncSubscriptionMember = (pool: any, member: any) => {
    runPoolMutation('/api/subscription-pools/' + pool.id + '/members/' + member.id + '/sync', 'post').catch(() => undefined);
  };

  const impactText = (impact: any) => {
    const after = impact.after || {};
    const remaining = after.seats_remaining == null ? 'Unlimited' : after.seats_remaining;
    return `${impact.warning}\n\nResult: ${after.total_seats ?? 'Unlimited'} purchased, ${after.seats_used} used, ${remaining} remaining${after.overage ? `, ${after.overage} over capacity` : ''}.`;
  };

  const unlinkSubscriptionMember = (pool: any, member: any) => {
    runPoolMutation('/api/subscription-pools/' + pool.id + '/members/' + member.id, 'delete')
      .then((preview) => {
        if (window.confirm(impactText(preview.impact))) {
          return runPoolMutation('/api/subscription-pools/' + pool.id + '/members/' + member.id, 'delete', { confirm: true });
        }
      }).catch(() => undefined);
  };

  const moveSubscriptionPool = (pool: any) => {
    if (!poolMoveOrganizationId) return;
    runPoolMutation('/api/subscription-pools/' + pool.id + '/organization', 'put', { organization_id: poolMoveOrganizationId })
      .then((preview) => {
        if (window.confirm(impactText(preview.impact))) {
          return runPoolMutation('/api/subscription-pools/' + pool.id + '/organization', 'put', { organization_id: poolMoveOrganizationId, confirm: true })
            .then(() => loadSubscriptionPools(selectedOrganization.id));
        }
      }).catch(() => undefined);
  };

  const handleEditSubmit = (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidatedEdit(true);
      focusFirstInvalidField(form);
      return;
    }

    if (form.checkValidity() !== false) {
        setValidatedEdit(true);
        setErrorEdit("");
        setSavingOrganization(true);

        let token = sessionStorage.getItem("token");
        fetch(ventrisConfig.url + '/api/organization/' + selectedOrganization.id, {
          method: 'put',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            name: name,
            parent_organization_id: (organizationId == "" ? null : organizationId),
            subscription_key: subscriptionKey.trim() === "" ? null : subscriptionKey.trim(),
            starts_at: subscriptionStartDate === "" ? null : subscriptionStartDate,
            expiration_date: expirationDate === "" ? null : expirationDate,
            total_seats: totalSeats === "" ? null : Number(totalSeats),
            schoolday_type: organizationType === "" ? null : organizationType,
            use_case: useCase,
            assessment_access: user.can_manage_assessment_access ? assessmentAccess : undefined,
            sso_short_code: ssoShortCode.trim() === "" ? null : ssoShortCode.trim(),
            cognito_domain: cognitoDomain.trim() === "" ? null : cognitoDomain.trim(),
            cognito_client_id: cognitoClientId.trim() === "" ? null : cognitoClientId.trim(),
            cognito_client_secret: cognitoClientSecret.trim() === "" ? null : cognitoClientSecret.trim(),
            cognito_redirect_uri: cognitoRedirectUri.trim() === "" ? null : cognitoRedirectUri.trim(),
            clear_cognito_client_secret: clearCognitoClientSecret,
            use_schoolday_for_rostering: useSchoolDayForRostering,
            schoolday_client_id: schoolDayClientId.trim() === "" ? null : schoolDayClientId.trim(),
            schoolday_client_secret: schoolDayClientSecret.trim() === "" ? null : schoolDayClientSecret.trim(),
            clear_schoolday_client_secret: clearSchoolDayClientSecret
          })
        }).then(function (response) {
          return response.json();
        }).then(async function (data) {
          if (data.success) {
            updateCurrentUserUseCase(selectedOrganization.id, useCase);
            loadOrganizations();
            loadOrganizationResults(1);
            setHierarchyVersion((current) => current + 1);
            setShowEditModal(false);
            setPage(1);
            const externalSyncWarning = data.sync_warning || data.subscription_sync_warning;
            setStatusVariant(externalSyncWarning ? "warning" : "success");
            setStatusMessage(externalSyncWarning || (data.sync_summary ? "Organization saved and SchoolDay sync completed successfully." : "Organization saved successfully."));
          } else {
            setErrorEdit(data.message || "An error occured while editing this organization. Please try again!");
          }
          setSavingOrganization(false);
        }).catch(() => {
          setErrorEdit("An error occured while editing this organization. Please try again!");
          setSavingOrganization(false);
        });
    }
  };

  const createOrganization = (defaultType = "") => {
    setSelectedOrganization({});
    setSelectedOrganizationId(-1);
    setName("");
    setOrganizationId("");
    setSubscriptionKey("");
    setSubscriptionStartDate("");
    setExpirationDate("");
    setTotalSeats("");
    setOrganizationType(defaultType);
    setUseCase("School");
    setAssessmentAccess(["WRA"]);
    setSsoShortCode("");
    setCognitoDomain("");
    setCognitoClientId("");
    setCognitoClientSecret("");
    setCognitoRedirectUri("");
    setClearCognitoClientSecret(false);
    setUseSchoolDayForRostering(false);
    setSchoolDayClientId("");
    setSchoolDayClientSecret("");
    setClearSchoolDayClientSecret(false);
    setShowCreateModal(true);
  }

  const editHierarchyUser = (hierarchyUser: any) => {
    setSelectedUser(hierarchyUser);
    setUserEmail(hierarchyUser.email || "");
    setUserPassword("");
    setUserFirstName(hierarchyUser.first_name || "");
    setUserLastName(hierarchyUser.last_name || "");
    setUserRole(hierarchyUser.role || "Clinician");
    setUserOrganizationId(String(hierarchyUser.organization_id || ""));
    setUserEditError("");
    setShowEditUserModal(true);
  };

  const handleUserEditSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.currentTarget.checkValidity() === false) {
      focusFirstInvalidField(event.currentTarget);
      return;
    }

    setSavingUser(true);
    setUserEditError("");
    fetch(ventrisConfig.url + "/api/user/" + selectedUser.id, {
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        email: userEmail,
        password: userPassword,
        name: `${userFirstName} ${userLastName}`,
        first_name: userFirstName,
        last_name: userLastName,
        role: userRole,
        organization_id: userOrganizationId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.success) {
          setUserEditError(data.message || `An error occurred while editing this ${terms.teacher.toLowerCase()}.`);
          return;
        }
        setShowEditUserModal(false);
        setHierarchyVersion((current) => current + 1);
      })
      .catch(() => setUserEditError(`An error occurred while editing this ${terms.teacher.toLowerCase()}.`))
      .finally(() => setSavingUser(false));
  };

  const editHierarchyStudent = (hierarchyStudent: any) => {
    setStudentEditError("");
    fetch(ventrisConfig.url + "/api/student/" + hierarchyStudent.id, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const student = data.success ? { ...hierarchyStudent, ...data.student } : hierarchyStudent;
        setSelectedStudent(student);
        setStudentFirstName(student.first_name || "");
        setStudentLastName(student.last_name || "");
        setStudentGrade(student.grade || "");
        setStudentBirthdate((student.birthdate || "").split("T")[0]);
        setStudentCode(student.student_code || "");
        setStudentOrganizationId(String(student.organization_id || hierarchyStudent.organization_id || ""));
        setShowEditStudentModal(true);
      })
      .catch(() => setStudentEditError(`An error occurred while loading this ${terms.student.toLowerCase()}.`));
  };

  const handleStudentEditSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.currentTarget.checkValidity() === false) {
      focusFirstInvalidField(event.currentTarget);
      return;
    }

    setSavingStudent(true);
    setStudentEditError("");
    fetch(ventrisConfig.url + "/api/student/" + selectedStudent.id, {
      method: "put",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        organization_id: studentOrganizationId,
        first_name: studentFirstName,
        last_name: studentLastName,
        grade: studentGrade,
        birthdate: studentBirthdate,
        student_code: studentCode,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.success) {
          setStudentEditError(data.message || `An error occurred while editing this ${terms.student.toLowerCase()}.`);
          return;
        }
        setShowEditStudentModal(false);
        setHierarchyVersion((current) => current + 1);
      })
      .catch(() => setStudentEditError(`An error occurred while editing this ${terms.student.toLowerCase()}.`))
      .finally(() => setSavingStudent(false));
  };

  const handleCreateSubmit = (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidatedCreate(true);
      focusFirstInvalidField(form);
      return;
    }

    if (form.checkValidity() !== false) {
        setValidatedCreate(true);
        setErrorCreate("");
        setSavingOrganization(true);

        let token = sessionStorage.getItem("token");
        const includeIntegrationFields = showCreateIntegrationFields;
        const includeSubscriptionKey = !createUnderSubscriptionOrganization;
        fetch(ventrisConfig.url + '/api/organization', {
          method: 'post',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            name: name,
            parent_organization_id: (organizationId == "" ? null : organizationId),
            subscription_key: includeSubscriptionKey && subscriptionKey.trim() !== "" ? subscriptionKey.trim() : null,
            starts_at: includeSubscriptionKey && subscriptionStartDate !== "" ? subscriptionStartDate : null,
            expiration_date: expirationDate === "" ? null : expirationDate,
            total_seats: totalSeats === "" ? null : Number(totalSeats),
            schoolday_type: organizationType === "" ? null : organizationType,
            use_case: useCase,
            assessment_access: user.can_manage_assessment_access ? assessmentAccess : undefined,
            sso_short_code: includeIntegrationFields && ssoShortCode.trim() !== "" ? ssoShortCode.trim() : null,
            cognito_domain: includeIntegrationFields && cognitoDomain.trim() !== "" ? cognitoDomain.trim() : null,
            cognito_client_id: includeIntegrationFields && cognitoClientId.trim() !== "" ? cognitoClientId.trim() : null,
            cognito_client_secret: includeIntegrationFields && cognitoClientSecret.trim() !== "" ? cognitoClientSecret.trim() : null,
            cognito_redirect_uri: includeIntegrationFields && cognitoRedirectUri.trim() !== "" ? cognitoRedirectUri.trim() : null,
            use_schoolday_for_rostering: includeIntegrationFields ? useSchoolDayForRostering : false,
            schoolday_client_id: includeIntegrationFields && schoolDayClientId.trim() !== "" ? schoolDayClientId.trim() : null,
            schoolday_client_secret: includeIntegrationFields && schoolDayClientSecret.trim() !== "" ? schoolDayClientSecret.trim() : null
          })
        }).then(function (response) {
          return response.json();
        }).then(async function (data) {
          if (data.success) {
            loadOrganizations();
            loadOrganizationResults(1);
            setShowCreateModal(false);
            setPage(1);
            const externalSyncWarning = data.sync_warning || data.subscription_sync_warning;
            setStatusVariant(externalSyncWarning ? "warning" : "success");
            setStatusMessage(externalSyncWarning || (data.sync_summary ? "Organization created and SchoolDay sync completed successfully." : "Organization created successfully."));
          } else {
            setErrorCreate(data.message || "An error occured while creating this organization. Please try again!");
          }
          setSavingOrganization(false);
        }).catch(() => {
          setErrorCreate("An error occured while creating this organization. Please try again!");
          setSavingOrganization(false);
        });
    }
  };

  const deleteOrganization = (organizationId: any) => {
    if (isAssociatedOrganization(organizationId)) {
      setStatusVariant("danger");
      setStatusMessage("Admins cannot delete organizations they are associated with.");
      return;
    }

    setSelectedOrganizationId(organizationId);
    setShowDeleteModal(true);
  }

  const actuallyDeleteOrganization = () => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/organization/' + selectedOrganizationId, {
      method: 'delete',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      if (data.success) {
        loadOrganizations();
        loadOrganizationResults(1);
        setPage(1);
        setShowDeleteModal(false);
        setStatusVariant("success");
        setStatusMessage("Organization deleted successfully.");
      } else {
        setStatusVariant("danger");
        setStatusMessage(data.message || "An error occurred while deleting this organization.");
      }
    });
  }

  const syncOrganization = (organizationId: any) => {
    setSyncingOrganizationId(organizationId);
    setStatusMessage("");

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/organization/' + organizationId + '/schoolday-sync', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setStatusVariant(data.success ? "success" : "danger");
      setStatusMessage(data.message || (data.success ? "SchoolDay sync completed successfully." : "SchoolDay sync failed."));
      if (data.success) {
        loadOrganizations();
        loadOrganizationResults(page);
      }
      setSyncingOrganizationId("");
    }).catch(() => {
      setStatusVariant("danger");
      setStatusMessage("SchoolDay sync failed.");
      setSyncingOrganizationId("");
    });
  }

  const syncSubscriptions = () => {
    setSyncingSubscriptions(true);
    setStatusMessage("");

    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/subscriptions/sync-organizations', {
      method: 'post',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setStatusVariant(data.success ? "success" : "danger");
      setStatusMessage(data.message || (data.success ? "Subscription sync completed successfully." : "Subscription sync failed."));
      if (data.success) {
        loadOrganizations();
        loadOrganizationResults(page);
      }
      setSyncingSubscriptions(false);
    }).catch(() => {
      setStatusVariant("danger");
      setStatusMessage("Subscription sync failed.");
      setSyncingSubscriptions(false);
    });
  }

  const actionFormatter = (cell: any, row: any) => {
    const editDisabled = !canEditOrganization(row);
    const deleteDisabled = !!row.schoolday_managed || isAssociatedOrganization(row.id);

    return (
      <div className="directory-row-actions">
        <Button variant="link" size="sm" onClick={() => editOrganization(row)} disabled={editDisabled}>Edit</Button>
        {row.use_schoolday_for_rostering ? <>
          <Button variant="link" size="sm" onClick={() => syncOrganization(row.id)} disabled={syncingOrganizationId == row.id}>Sync</Button>
        </> : null}
        <Button variant="link" size="sm" onClick={() => deleteOrganization(row.id)} disabled={deleteDisabled}>Delete</Button>
      </div>
    );
  }

  const nullableFormatter = (cell: any) => {
    return cell == null || cell === "" ? "None" : cell;
  }

  const expirationDateFormatter = (cell: any) => {
    if (cell == null || cell === "") {
      return "None";
    }
    return String(cell).split("T")[0];
  }

  const usageFormatter = (cell: any, row: any) => {
    return row.subscription_entitlement_mode === 'access_only'
      ? 'Not metered'
      : nullableFormatter(cell);
  }

  const columns = [
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      headerStyle: { width: '13%' }
    },
    {
      dataField: 'parent_organization_name',
      text: 'Parent',
      sort: true,
      headerStyle: { width: '12%' }
    },
    {
      dataField: 'schoolday_type',
      text: 'Type',
      sort: true,
      headerStyle: { width: '6%' },
      formatter: nullableFormatter
    },
    {
      dataField: 'use_case',
      text: 'Use Case',
      sort: true,
      headerStyle: { width: '7%' }
    },
    {
      dataField: 'subscription_key',
      text: 'Sub. Key',
      sort: true,
      headerStyle: { width: '12%' },
      formatter: nullableFormatter
    },
    {
      dataField: 'starts_at',
      text: 'Starts',
      sort: true,
      headerStyle: { width: '8%' },
      formatter: expirationDateFormatter
    },
    {
      dataField: 'expiration_date',
      text: 'Expires',
      sort: true,
      headerStyle: { width: '8%' },
      formatter: expirationDateFormatter
    },
    {
      dataField: 'total_seats',
      text: 'Seats',
      sort: true,
      headerStyle: { width: '6%' },
      formatter: nullableFormatter
    },
    {
      dataField: 'seats_used',
      text: 'Used',
      headerStyle: { width: '6%' },
      formatter: usageFormatter
    },
    {
      dataField: 'seats_remaining',
      text: 'Available',
      headerStyle: { width: '7%' },
      formatter: usageFormatter
    },
    {
      dataField: 'id',
      text: 'Actions',
      headerStyle: { width: '15%' },
      formatter: actionFormatter
    }
  ];

  const availableParentOrganizations = organizations.filter((organization: any) => !organization.schoolday_managed);
  const selectedOrganizationWithHierarchy = organizationById(selectedOrganization?.id) || selectedOrganization;
  const selectedDescendantIds = new Set(
    (selectedOrganizationWithHierarchy?.child_organizations || [])
      .map((childOrganization: any) => String(childOrganization?.id ?? childOrganization))
  );
  const editableParentOrganizations = availableParentOrganizations.filter((organization: any) => {
    if (!selectedOrganization?.id) {
      return true;
    }

    return String(organization.id) !== String(selectedOrganization.id)
      && !selectedDescendantIds.has(String(organization.id));
  });
  const canCreateOrganization = availableParentOrganizations.length > 0;
  const isVentrisLearningAdmin = associatedOrganizationIds().includes("1");
  const addOrganizationButtonLabel = terms.useCase === "School" ? "Add School or Class" : "Add an Organization";
  const editIntegrationOnly = canEditIntegrationSettingsForOrganization(selectedOrganization);
  const createParentOrganizationId = organizationId || user?.organization_id;
  const createUnderSubscriptionOrganization = organizationOrAncestorHasSubscriptionKey(createParentOrganizationId);
  const editUnderSubscriptionOrganization = organizationOrAncestorHasSubscriptionKey(selectedOrganization?.parent_organization_id);
  const showCreateSubscriptionDrivenFields = false;
  const showCreateIntegrationFields = isVentrisLearningAdmin || !createUnderSubscriptionOrganization;
  const showEditIntegrationFields = editIntegrationOnly || !editUnderSubscriptionOrganization;
  const hasSubscriptionPool = subscriptionPools.length > 0;
  const showLegacySubscriptionEditor = !subscriptionPoolsEnabled
    || (!subscriptionPoolsLoading && !subscriptionPoolError && !hasSubscriptionPool);

  const toggleAssessmentAccess = (assessment: AssessmentName) => {
    setAssessmentAccess((current) => current.includes(assessment)
      ? current.filter((item) => item !== assessment)
      : ASSESSMENT_OPTIONS.filter((item) => [...current, assessment].includes(item))
    );
  };

  const updateFilter = (organizations: any) => {
    setOrganizationFilter(organizations.join('|'));
    setPage(1);
  };

  const handleTableChange = (type: string, { page, sizePerPage, sortField, sortOrder }: any) => {
    if ((sortField && sortFieldName != sortField) || (sortDirection && sortDirection != sortOrder)) {
      setPage(1);
    } else {
      setPage(page);
    }
    setSizePerPage(sizePerPage);
    setSortFieldName(sortField ? sortField : "");
    setSortDirection(sortOrder ? sortOrder : "");
  }

  return (
    <Container fluid className="ventris-content-wrapper ventris-groups ventris-directory">
      <Header portal={sessionStorage.getItem("portal")!} page="organizations" />
      <Container as="main" id="main-content" tabIndex={-1}>
        <Row>
          <Col>
            <div className="page-header align-items-center directory-page-header">
              <h1 className="directory-page-title">
                <GroupPageIcon />
                <span>Directory</span>
              </h1>
              <Form.Control type="search" className="ventris-search" aria-label="Search organizations" placeholder="Search organizations" value={search} onChange={(event) => setSearch(event.target.value)} />
              <Button
                variant="secondary"
                className="ventris-button-secondary ventris-button-secondary-blue directory-view-toggle"
                onClick={() => setViewMode(viewMode === "hierarchy" ? "list" : "hierarchy")}
              >
                {viewMode === "hierarchy" ? "List View" : "Hierarchy View"}
              </Button>
              {viewMode === "list" && isVentrisLearningAdmin ? <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal" onClick={() => syncSubscriptions()} disabled={syncingSubscriptions}>{syncingSubscriptions ? <><Spinner as="span" animation="border" size="sm" className="me-2" />Syncing Subscriptions...</> : "Sync Subscriptions"}</Button> : null}
              {viewMode === "list" ? (
                <Button variant="primary" className="ventris-button-primary ventris-button-primary-blue" onClick={() => createOrganization()} disabled={!canCreateOrganization}>
                  <GroupIcon /> {addOrganizationButtonLabel}
                </Button>
              ) : terms.useCase === "School" && canCreateOrganization ? (
                <Button variant="primary" className="ventris-button-primary ventris-button-primary-blue" onClick={() => createOrganization("school")}>
                  <GroupIcon /> {addOrganizationButtonLabel}
                </Button>
              ) : null}
            </div>
            <AsyncStatus busy={syncingSubscriptions} busyMessage="Syncing subscriptions." completeMessage="Subscription sync finished." />
            <AsyncStatus busy={loadingOrganizationResults} busyMessage="Loading organizations." completeMessage="Organizations loaded." />
            {statusMessage !== "" ? <Alert variant={statusVariant} role={statusVariant === "danger" ? "alert" : "status"} aria-live={statusVariant === "danger" ? "assertive" : "polite"} className="mb-3">{statusMessage}</Alert> : null}
            {viewMode === "list" && organizationsLoaded && !canCreateOrganization ? <div className="mb-3 text-muted">All accessible parent organizations are managed by SchoolDay, so child organizations must be created by sync.</div> : null}
            <div className={showFilters && viewMode === "list" ? '' : 'hidden'}>
              {viewMode === "list" ? <OrganizationFilter updateFilter={updateFilter} organizations={organizations} /> : null}
            </div>
            {viewMode === "list" ? (
              <div className="flex flex-row organization-tabs-bar">
                <div className="directory-list-tab">View All</div>
                <div className="flex-grow" />
                <div className="ventris-action-links">
                  <Button variant="link" size="sm" className="ventris-action-link" onClick={() => setShowFilters(!showFilters)}><FilterIcon /> {showFilters ? 'Hide Filter' : 'Show Filter'}</Button>
                </div>
              </div>
            ) : null}
            {viewMode === "list" ? (
              <div aria-busy={loadingOrganizationResults || syncingSubscriptions}>
                <ResponsiveTableRegion label="Organizations">
                  <BootstrapTable keyField='id' data={organizationResults} columns={columns} bordered={false} remote={{pagination: true, sort: true}} pagination={paginationFactory({ page, sizePerPage, totalSize })} onTableChange={handleTableChange} wrapperClasses="directory-table" noDataIndication="No organizations match your search." />
                </ResponsiveTableRegion>
              </div>
            ) : (
              <OrganizationHierarchyView
                key={hierarchyVersion}
                active={viewMode === "hierarchy"}
                search={search}
                onEditOrganization={editOrganization}
                onEditUser={editHierarchyUser}
                onEditStudent={editHierarchyStudent}
                canEditOrganization={canEditOrganization}
                onHierarchyChanged={() => {
                  loadOrganizations();
                  loadOrganizationResults(1);
                }}
              />
            )}
          </Col>
        </Row>
      </Container>
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this item? Deletion is permanent and cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="ventris-button-secondary ventris-button-secondary-teal half-width" onClick={() => setShowDeleteModal(false)}>No, Cancel</Button>
          <Button variant="primary" className="ventris-button-primary ventris-button-primary-teal half-width" onClick={() => actuallyDeleteOrganization()}>Yes, Confirm Delete</Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas show={showEditModal} onHide={() => setShowEditModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="edit-organization-title">
          <Offcanvas.Header className="offcanvas-header-blue" closeButton>
              <Offcanvas.Title id="edit-organization-title">Edit Organization</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-organization-form" validated={validatedEdit} ref={editFormRef} onSubmit={handleEditSubmit}>
              <Form.Group className="mb-3" controlId="edit-organization-name">
                  <Form.Label>Organization Name:</Form.Label>
                  <Form.Control required type="text" autoComplete="organization" placeholder="Name" value={name} onChange={(event) => setName(event.target.value)} disabled={editIntegrationOnly} />
                  <Form.Control.Feedback type="invalid">Please enter a name.</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-parent-organization">
                  <Form.Label>Parent Organization:</Form.Label>
                  <OrganizationPicker
                    ariaLabel="Parent Organization"
                    organizations={editableParentOrganizations}
                    value={organizationId}
                    onChange={setOrganizationId}
                    includeNone={true}
                    noneLabel="None"
                    disabled={editIntegrationOnly}
                  />
              </Form.Group>
              {showLegacySubscriptionEditor ? <Form.Group className="mb-3" controlId="edit-subscription-key">
                  <Form.Label>{subscriptionPoolsEnabled ? 'Initial Subscription Key:' : 'Subscription Key:'}</Form.Label>
                  <Form.Control type="text" placeholder="Subscription Key" value={subscriptionKey} onChange={(event) => setSubscriptionKey(event.target.value)} disabled={editIntegrationOnly} />
                  {subscriptionPoolsEnabled ? <Form.Text>This field is only for an organization that does not yet have a subscription pool.</Form.Text> : null}
              </Form.Group> : null}
              <Form.Group className="mb-3" controlId="edit-organization-type">
                  <Form.Label>Organization Type:</Form.Label>
                  <Form.Select value={organizationType} onChange={(event) => setOrganizationType(event.target.value)} disabled={editIntegrationOnly}>
                    <option value="">Organization</option>
                    <option value="class">{terms.class}</option>
                    <option value="school">School</option>
                    <option value="district">District</option>
                  </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-use-case">
                  <Form.Label>Use Case:</Form.Label>
                  <Form.Select required value={useCase} onChange={(event) => setUseCase(event.target.value)} disabled={editIntegrationOnly}>
                    <option value="School">School</option>
                    <option value="SLP">SLP</option>
                  </Form.Select>
              </Form.Group>
              {user.can_manage_assessment_access ? <Form.Group className="mb-3" controlId="assessmentAccessEdit">
                  <Form.Label>Assessment Access:</Form.Label>
                  <div className="assessment-access-options">
                    {ASSESSMENT_OPTIONS.map((assessment) => <Form.Check
                      key={assessment}
                      inline
                      type="checkbox"
                      id={`edit-assessment-${assessment.toLowerCase()}`}
                      label={assessment}
                      checked={assessmentAccess.includes(assessment)}
                      onChange={() => toggleAssessmentAccess(assessment)}
                    />)}
                  </div>
                  <Form.Text>ATLAS can be assigned now and will become launchable when its assessment is added.</Form.Text>
              </Form.Group> : null}
              {showLegacySubscriptionEditor ? <><Form.Group className="mb-3" controlId="edit-expiration-date">
                  <Form.Label>Expiration Date:</Form.Label>
                  <Form.Control type="date" value={expirationDate} onChange={(event) => setExpirationDate(event.target.value)} disabled />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-subscription-start-date">
                  <Form.Label>Subscription Term Start:</Form.Label>
                  <Form.Control type="date" value={subscriptionStartDate} onChange={(event) => setSubscriptionStartDate(event.target.value)} disabled={editIntegrationOnly || subscriptionKey.trim() === ""} />
                  <Form.Text>Only tests launched or completed during this term count toward its seats.</Form.Text>
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-total-seats">
                  <Form.Label>Seats Purchased:</Form.Label>
                  <Form.Control type="number" min="0" step="1" placeholder="Total Seats" value={totalSeats} onChange={(event) => setTotalSeats(event.target.value)} disabled />
              </Form.Group></> : null}
              {subscriptionPoolsEnabled && (subscriptionPoolsEnabledForOrganization || subscriptionPoolsLoading || subscriptionPoolError) ? <section className="border rounded p-3 mb-3" aria-labelledby="subscription-orders-title">
                <h2 id="subscription-orders-title" className="h5">Subscription Orders</h2>
                {subscriptionPoolsLoading ? <div><Spinner as="span" animation="border" size="sm" className="me-2" />Loading subscription orders...</div> : null}
                {subscriptionPoolError ? <Alert variant="danger" className="mt-2">{subscriptionPoolError}</Alert> : null}
                {!subscriptionPoolsLoading && subscriptionPools.length === 0 ? <p className="text-muted mb-0">No subscription pool is associated with this organization.</p> : null}
                {!subscriptionPoolsLoading ? <fieldset className="border rounded p-2 mt-3">
                  <legend className="h6">Add WooCommerce subscription order</legend>
                  <Form.Text className="d-block mb-2">The WooCommerce product determines the assessment, term, and whether this order grants access or metered seats.</Form.Text>
                  <Form.Group className="mb-2" controlId="new-subscription-order-key">
                    <Form.Label>Subscription Key</Form.Label>
                    <Form.Control value={newSubscriptionKey} onChange={(event) => setNewSubscriptionKey(event.target.value)} />
                  </Form.Group>
                  <Form.Group className="mb-2" controlId="new-subscription-order-purchaser">
                    <Form.Label>Purchasing Organization</Form.Label>
                    <OrganizationPicker organizations={organizations} value={newSubscriptionPurchaserId} onChange={setNewSubscriptionPurchaserId} />
                  </Form.Group>
                  <Button type="button" size="sm" disabled={subscriptionPoolBusy || !newSubscriptionKey.trim()} onClick={addSubscriptionOrder}>Add and Sync Order</Button>
                </fieldset> : null}
                {subscriptionPools.map((pool: any) => <div key={pool.id} className="mt-3">
                  <dl className="row mb-2">
                    <dt className="col-6">Entitlement root</dt><dd className="col-6">{pool.organization_name}</dd>
                    <dt className="col-6">Assessment</dt><dd className="col-6">{pool.assessment_type || 'WRA'}</dd>
                    <dt className="col-6">Entitlement</dt><dd className="col-6">{pool.entitlement_mode === 'access_only' ? 'Access only' : 'Metered seats'}</dd>
                    <dt className="col-6">Term</dt><dd className="col-6">{pool.starts_at || 'Open'} – {pool.expiration_date || 'Open'}</dd>
                    <dt className="col-6">Capacity</dt><dd className="col-6">{pool.entitlement_mode === 'access_only' ? <>{pool.total_seats ?? 0} purchased / access only (not seat metered)</> : <>{pool.total_seats ?? 'Unlimited'} purchased / {pool.seats_used} used / {pool.seats_remaining ?? 'Unlimited'} remaining</>}</dd>
                    {pool.overage > 0 ? <><dt className="col-6 text-danger">Over capacity</dt><dd className="col-6 text-danger">{pool.overage} seats</dd></> : null}
                  </dl>
                  <div className="d-grid gap-2">
                    {(pool.members || []).map((member: any) => <article key={member.id} className="border rounded p-2">
                      <div className="d-flex justify-content-between gap-2 flex-wrap">
                        <strong>{member.subscription_key}{member.is_primary ? ' (Primary)' : ''}</strong>
                        <span>{(member.entitlement_mode || pool.entitlement_mode) === 'access_only' ? `${member.total_seats ?? 0} access seats` : `${member.total_seats ?? 'Unlimited'} seats`}</span>
                      </div>
                      <div className="small text-muted">
                        Purchaser: {member.purchasing_organization_name || member.purchasing_organization_id}<br />
                        Assessment/entitlement: {member.assessment_type || pool.assessment_type || 'WRA'} / {(member.entitlement_mode || pool.entitlement_mode) === 'access_only' ? 'access only' : 'metered seats'}<br />
                        Source/status: {member.source || 'legacy'} / {member.status || 'unknown'}<br />
                        Dates: {member.starts_at || 'Open'} – {member.expiration_date || 'Open'}<br />
                        Last sync: {member.last_synced_at ? new Date(member.last_synced_at).toLocaleString() : 'Never'}
                      </div>
                      {member.sync_error ? <Alert variant="warning" className="py-1 px-2 my-2">{member.sync_error}</Alert> : null}
                      <div className="d-flex gap-2 flex-wrap mt-2">
                        {!member.is_primary ? <Button type="button" size="sm" variant="outline-primary" disabled={subscriptionPoolBusy || !member.contributes_seats} onClick={() => setPrimarySubscription(pool, member.id)}>Make Primary</Button> : null}
                        <Button type="button" size="sm" variant="outline-primary" disabled={subscriptionPoolBusy} onClick={() => syncSubscriptionMember(pool, member)}>Sync</Button>
                        <Button type="button" size="sm" variant="outline-danger" disabled={subscriptionPoolBusy} onClick={() => unlinkSubscriptionMember(pool, member)}>Unlink</Button>
                      </div>
                    </article>)}
                  </div>
                  <fieldset className="border-top mt-3 pt-3">
                    <legend className="h6">Move entitlement root</legend>
                    <Form.Group className="mb-2" controlId={`pool-${pool.id}-root`}>
                      <Form.Label>Organization</Form.Label>
                      <OrganizationPicker organizations={organizations} value={poolMoveOrganizationId} onChange={setPoolMoveOrganizationId} />
                    </Form.Group>
                    <Button type="button" size="sm" variant="outline-primary" disabled={subscriptionPoolBusy || !poolMoveOrganizationId || String(poolMoveOrganizationId) === String(pool.organization_id)} onClick={() => moveSubscriptionPool(pool)}>Preview and Move Pool</Button>
                  </fieldset>
                </div>)}
              </section> : null}
              {showEditIntegrationFields ? <>
              <Form.Group className="mb-3" controlId="edit-sso-short-code">
                  <Form.Label>SSO Short Code:</Form.Label>
                  <Form.Control type="text" placeholder="SSO Short Code" value={ssoShortCode} onChange={(event) => setSsoShortCode(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-cognito-domain">
                  <Form.Label>Cognito Domain:</Form.Label>
                  <Form.Control type="text" placeholder="my-org.auth.us-east-1.amazoncognito.com" value={cognitoDomain} onChange={(event) => setCognitoDomain(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-cognito-client-id">
                  <Form.Label>Cognito Client ID:</Form.Label>
                  <Form.Control type="text" placeholder="Cognito Client ID" value={cognitoClientId} onChange={(event) => setCognitoClientId(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-cognito-client-secret">
                  <Form.Label>Cognito Client Secret:</Form.Label>
                  <Form.Control type="password" placeholder="Leave blank to keep existing secret" value={cognitoClientSecret} onChange={(event) => setCognitoClientSecret(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-clear-cognito-client-secret">
                <Form.Check
                  type="checkbox"
                  label="Clear existing Cognito client secret"
                  checked={clearCognitoClientSecret}
                  onChange={(event) => setClearCognitoClientSecret(event.target.checked)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-cognito-redirect-uri">
                  <Form.Label>Cognito Redirect URI:</Form.Label>
                  <Form.Control type="text" placeholder="https://app.ventrislearning.com/sso/callback" value={cognitoRedirectUri} onChange={(event) => setCognitoRedirectUri(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-use-schoolday-for-rostering">
                <Form.Check
                  type="checkbox"
                  label="Use SchoolDay for Rostering"
                  checked={useSchoolDayForRostering}
                  onChange={(event) => setUseSchoolDayForRostering(event.target.checked)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-schoolday-client-id">
                  <Form.Label>SchoolDay Client ID:</Form.Label>
                  <Form.Control type="text" placeholder="SchoolDay Client ID" value={schoolDayClientId} onChange={(event) => setSchoolDayClientId(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-schoolday-client-secret">
                  <Form.Label>SchoolDay Client Secret:</Form.Label>
                  <Form.Control type="password" placeholder="Leave blank to keep existing secret" value={schoolDayClientSecret} onChange={(event) => setSchoolDayClientSecret(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="edit-clear-schoolday-client-secret">
                <Form.Check
                  type="checkbox"
                  label="Clear existing SchoolDay client secret"
                  checked={clearSchoolDayClientSecret}
                  onChange={(event) => setClearSchoolDayClientSecret(event.target.checked)}
                />
              </Form.Group>
              </> : null}
              <div className="modal-form-actions">
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width" disabled={savingOrganization}>
                  {savingOrganization ? <><Spinner as="span" animation="border" size="sm" className="me-2" />Saving...</> : "Save"}
                </Button>
              </div>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas show={showCreateModal} onHide={() => setShowCreateModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="create-organization-title">
          <Offcanvas.Header className="offcanvas-header-blue" closeButton>
              <Offcanvas.Title id="create-organization-title">Create Organization</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form className="edit-organization-form" validated={validatedCreate} ref={createFormRef} onSubmit={handleCreateSubmit}>
              <Form.Group className="mb-3" controlId="create-organization-name">
                  <Form.Label>Organization Name:</Form.Label>
                  <Form.Control required type="text" autoComplete="organization" placeholder="Name" value={name} onChange={(event) => setName(event.target.value)} />
                  <Form.Control.Feedback type="invalid">Please enter a name.</Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-parent-organization">
                  <Form.Label>Parent Organization:</Form.Label>
                  <OrganizationPicker
                    ariaLabel="Parent Organization"
                    organizations={availableParentOrganizations}
                    value={organizationId}
                    onChange={setOrganizationId}
                    includeNone={true}
                    noneLabel="None"
                  />
              </Form.Group>
              {!createUnderSubscriptionOrganization ? <Form.Group className="mb-3" controlId="create-subscription-key">
                  <Form.Label>Subscription Key:</Form.Label>
                  <Form.Control type="text" placeholder="Subscription Key" value={subscriptionKey} onChange={(event) => setSubscriptionKey(event.target.value)} />
              </Form.Group> : null}
              {!createUnderSubscriptionOrganization ? <Form.Group className="mb-3" controlId="create-subscription-start-date">
                  <Form.Label>Subscription Term Start:</Form.Label>
                  <Form.Control required={subscriptionKey.trim() !== ""} type="date" value={subscriptionStartDate} onChange={(event) => setSubscriptionStartDate(event.target.value)} disabled={subscriptionKey.trim() === ""} />
                  <Form.Control.Feedback type="invalid">Please enter the date this subscription term begins.</Form.Control.Feedback>
              </Form.Group> : null}
              <Form.Group className="mb-3" controlId="create-organization-type">
                  <Form.Label>Organization Type:</Form.Label>
                  <Form.Select value={organizationType} onChange={(event) => setOrganizationType(event.target.value)}>
                    <option value="">Organization</option>
                    <option value="class">{terms.class}</option>
                    <option value="school">School</option>
                    <option value="district">District</option>
                  </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-use-case">
                  <Form.Label>Use Case:</Form.Label>
                  <Form.Select required value={useCase} onChange={(event) => setUseCase(event.target.value)}>
                    <option value="School">School</option>
                    <option value="SLP">SLP</option>
                  </Form.Select>
              </Form.Group>
              {user.can_manage_assessment_access ? <Form.Group className="mb-3" controlId="assessmentAccessCreate">
                  <Form.Label>Assessment Access:</Form.Label>
                  <div className="assessment-access-options">
                    {ASSESSMENT_OPTIONS.map((assessment) => <Form.Check
                      key={assessment}
                      inline
                      type="checkbox"
                      id={`create-assessment-${assessment.toLowerCase()}`}
                      label={assessment}
                      checked={assessmentAccess.includes(assessment)}
                      onChange={() => toggleAssessmentAccess(assessment)}
                    />)}
                  </div>
                  <Form.Text>ATLAS can be assigned now and will become launchable when its assessment is added.</Form.Text>
              </Form.Group> : null}
              {showCreateSubscriptionDrivenFields ? <>
              <Form.Group className="mb-3" controlId="create-expiration-date">
                  <Form.Label>Expiration Date:</Form.Label>
                  <Form.Control type="date" value={expirationDate} onChange={(event) => setExpirationDate(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-total-seats">
                  <Form.Label>Seats Purchased:</Form.Label>
                  <Form.Control type="number" min="0" step="1" placeholder="Total Seats" value={totalSeats} onChange={(event) => setTotalSeats(event.target.value)} />
              </Form.Group>
              </> : null}
              {showCreateIntegrationFields ? <>
              <Form.Group className="mb-3" controlId="create-sso-short-code">
                  <Form.Label>SSO Short Code:</Form.Label>
                  <Form.Control type="text" placeholder="SSO Short Code" value={ssoShortCode} onChange={(event) => setSsoShortCode(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-cognito-domain">
                  <Form.Label>Cognito Domain:</Form.Label>
                  <Form.Control type="text" placeholder="my-org.auth.us-east-1.amazoncognito.com" value={cognitoDomain} onChange={(event) => setCognitoDomain(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-cognito-client-id">
                  <Form.Label>Cognito Client ID:</Form.Label>
                  <Form.Control type="text" placeholder="Cognito Client ID" value={cognitoClientId} onChange={(event) => setCognitoClientId(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-cognito-client-secret">
                  <Form.Label>Cognito Client Secret:</Form.Label>
                  <Form.Control type="password" placeholder="Cognito Client Secret" value={cognitoClientSecret} onChange={(event) => setCognitoClientSecret(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-cognito-redirect-uri">
                  <Form.Label>Cognito Redirect URI:</Form.Label>
                  <Form.Control type="text" placeholder="https://app.ventrislearning.com/sso/callback" value={cognitoRedirectUri} onChange={(event) => setCognitoRedirectUri(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-use-schoolday-for-rostering">
                <Form.Check
                  type="checkbox"
                  label="Use SchoolDay for Rostering"
                  checked={useSchoolDayForRostering}
                  onChange={(event) => setUseSchoolDayForRostering(event.target.checked)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-schoolday-client-id">
                  <Form.Label>SchoolDay Client ID:</Form.Label>
                  <Form.Control type="text" placeholder="SchoolDay Client ID" value={schoolDayClientId} onChange={(event) => setSchoolDayClientId(event.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3" controlId="create-schoolday-client-secret">
                  <Form.Label>SchoolDay Client Secret:</Form.Label>
                  <Form.Control type="password" placeholder="SchoolDay Client Secret" value={schoolDayClientSecret} onChange={(event) => setSchoolDayClientSecret(event.target.value)} />
              </Form.Group>
              </> : null}
              <div className="modal-form-actions">
                <Button type="submit" variant="primary" className="ventris-button-primary ventris-button-primary-teal full-width" disabled={savingOrganization}>
                  {savingOrganization ? <><Spinner as="span" animation="border" size="sm" className="me-2" />Saving...</> : "Save"}
                </Button>
              </div>
            </Form>
          </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas show={showEditUserModal} onHide={() => setShowEditUserModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="organization-edit-user-title">
        <Offcanvas.Header className="offcanvas-header-blue" closeButton>
          <Offcanvas.Title id="organization-edit-user-title">Edit {terms.teacher}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form onSubmit={handleUserEditSubmit}>
            {userEditError ? <Alert variant="danger">{userEditError}</Alert> : null}
            <Form.Group className="mb-3" controlId="organization-edit-user-email">
              <Form.Label>Email Address:</Form.Label>
              <Form.Control required type="email" autoComplete="email" value={userEmail} onChange={(event) => setUserEmail(event.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-user-password">
              <Form.Label>Password:</Form.Label>
              <Form.Control type="password" autoComplete="new-password" placeholder="Password (Optional)" value={userPassword} onChange={(event) => setUserPassword(event.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-user-first-name">
              <Form.Label>First Name:</Form.Label>
              <Form.Control required type="text" autoComplete="given-name" value={userFirstName} onChange={(event) => setUserFirstName(event.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-user-last-name">
              <Form.Label>Last Name:</Form.Label>
              <Form.Control required type="text" autoComplete="family-name" value={userLastName} onChange={(event) => setUserLastName(event.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-user-role">
              <Form.Label>Role:</Form.Label>
              <Form.Select required value={userRole} onChange={(event) => setUserRole(event.target.value)}>
                <option value="Clinician">{terms.teacher}</option>
                <option value="Admin">Admin</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-user-organization">
              <Form.Label>Organization:</Form.Label>
              <OrganizationPicker organizations={availableParentOrganizations} value={userOrganizationId} onChange={setUserOrganizationId} />
            </Form.Group>
            <Button type="submit" className="ventris-button-primary ventris-button-primary-teal full-width" disabled={savingUser}>
              {savingUser ? "Saving..." : "Save Changes"}
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas show={showEditStudentModal} onHide={() => setShowEditStudentModal(false)} placement="end" scroll={false} backdrop={true} aria-labelledby="organization-edit-student-title">
        <Offcanvas.Header className="offcanvas-header-purple" closeButton>
          <Offcanvas.Title id="organization-edit-student-title">Edit {terms.student}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form onSubmit={handleStudentEditSubmit}>
            {studentEditError ? <Alert variant="danger">{studentEditError}</Alert> : null}
            <Form.Group className="mb-3" controlId="organization-edit-student-organization">
              <Form.Label>Organization:</Form.Label>
              <OrganizationPicker organizations={availableParentOrganizations} value={studentOrganizationId} onChange={setStudentOrganizationId} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-student-first-name">
              <Form.Label>First Name:</Form.Label>
              <Form.Control required type="text" autoComplete="given-name" value={studentFirstName} onChange={(event) => setStudentFirstName(event.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-student-last-name">
              <Form.Label>Last Name:</Form.Label>
              <Form.Control required type="text" autoComplete="family-name" value={studentLastName} onChange={(event) => setStudentLastName(event.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-student-grade">
              <Form.Label>Grade:</Form.Label>
              <Form.Select required value={studentGrade} onChange={(event) => setStudentGrade(event.target.value)}>
                {["PK", "K", "1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th"].map((gradeOption) => (
                  <option key={gradeOption} value={gradeOption}>{gradeOption}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-student-birthdate">
              <Form.Label>Birthdate:</Form.Label>
              <Form.Control required type="date" value={studentBirthdate} onChange={(event) => setStudentBirthdate(event.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="organization-edit-student-code">
              <Form.Label>{terms.student} Code:</Form.Label>
              <Form.Control required type="text" value={studentCode} onChange={(event) => setStudentCode(event.target.value)} />
            </Form.Group>
            <Button type="submit" className="ventris-button-primary ventris-button-primary-teal full-width" disabled={savingStudent}>
              {savingStudent ? "Saving..." : "Save Changes"}
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default AdminOrganizations;
